import React, { useState, useEffect } from "react";
import { Box, Tabs, Tab, Divider } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import StorageIcon from "@mui/icons-material/Storage";
import ALMIntegrationFeature from "./ALMIntegrationFeature";
import TestManagementFeature from "./TestManagementFeature";
import "./RTMSettings.css";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`rtm-settings-tabpanel-${index}`}
      aria-labelledby={`rtm-settings-tab-${index}`}
      {...other}
      className="settings-tab-panel"
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `rtm-settings-tab-${index}`,
    "aria-controls": `rtm-settings-tabpanel-${index}`,
  };
}

const RTMSettings = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [rtmConfig, setRtmConfig] = useState({
    activeALM: "",
    almProviders: {},
    mappings: [],
  });
  const [projectId, setProjectId] = useState("");
  const [siteId, setSiteId] = useState("");

  const projectIndex = sessionStorage.getItem("selectedProjectIndex");
  const siteIndex = sessionStorage.getItem("selectedSiteIndex");
  const userDetails = JSON.parse(sessionStorage.getItem("UserDetails"));

  useEffect(() => {
    fetchRTMSettings();
  }, []);

  const fetchRTMSettings = async () => {
    const pId =
      userDetails?.data?.User?.rights?.Projects?.[projectIndex]?.projectId ||
      "";
    const sId =
      userDetails?.data?.User?.rights?.Projects?.[projectIndex]?.sites?.[
        siteIndex
      ]?.siteid || "";

    if (!pId || !sId) return;
    setProjectId(pId);
    setSiteId(sId);

    const headerData = {
      Authorization: sessionStorage.getItem("authToken") || "",
      "ch-subscription-key":
        userDetails?.data?.User?.["ch-subscription-key"] || "",
    };

    const url = `${window.configs.BASE_API_URL}${window.configs.ADMIN_SERVICE_PROJECT_URL}/${pId}/${sId}`;
    try {
      const result = await axios.get(url, { headers: headerData });
      if (result.data.status === "success") {
        const rtm = result.data.info.rtm_settings || {};
       
        setRtmConfig({
          activeALM: rtm.activeALM || "",
          almProviders: rtm.almProviders || {},
         // mappings: rtm.mappings || [],
        });
      }
    } catch (error) {
      console.error("Error fetching RTM settings:", error);
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const isJiraActive = rtmConfig.activeALM?.toLowerCase() === "jira";

  const tabs = [
    {
      label: (
        <Box className="tab-label-box">
          <IntegrationInstructionsIcon fontSize="small" />
          <span>ALM Integration</span>
        </Box>
      ),
      component: ALMIntegrationFeature,
      config: rtmConfig,
      key: "alm",
    },
    {
      label: (
        <Box className="tab-label-box">
          <StorageIcon fontSize="small" />
          <span>Test Management</span>
        </Box>
      ),
      component: TestManagementFeature,
      config:
        rtmConfig.almProviders?.[rtmConfig.activeALM]?.testManagement || {},
      key: "tm",
      disabled: !isJiraActive,
    },
  ];

  return (
    <>
      <div className="card custcard">
        <div className="cord-body">
          <div className="testHeading">
            <label className="headermsg1 ml-5">RTM Settings</label>
          </div>
        </div>
      </div>

      <div className="card custcard">
        <ToastContainer position="bottom-right" autoClose={3000} />
        <div className="cord-body mt-3" style={{ overflowY: "hidden" }}>
          <Box className="settings-box-container settings-box-column">
            <Box className="settings-tabs-wrapper">
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                textColor="primary"
                indicatorColor="primary"
                className="settings-tabs-container"
                variant="fullWidth"
              >
                {tabs.map((tab, index) => (
                  <Tab
                    key={index}
                    label={tab.label}
                    {...a11yProps(index)}
                    disabled={tab.disabled}
                  />
                ))}
              </Tabs>
              <Divider />
            </Box>

            {tabs.map((tab, index) => (
              <TabPanel key={index} value={selectedTab} index={index}>
                <tab.component
                  projectId={projectId}
                  siteId={siteId}
                  config={tab.config}
                  onUpdate={fetchRTMSettings}
                />
              </TabPanel>
            ))}
          </Box>
        </div>
      </div>
    </>
  );
};

export default RTMSettings;
